// Thin wrapper around window.location.reload so it can be mocked in tests —
// jsdom locks window.location, making the global impossible to spy on directly.
export const reloadWindow = () => window.location.reload();
